import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import "~/css/reception/VisitorInfoInputPage.css";
import "~/css/reception/common.css";
import VisitorInfoInputScreen from "~/components/VisitorInfoInputScreen";
import ReceptionHeader from "~/components/ReceptionHeader";
import { runReceptionBack } from "~/utils/receptionNavigation";
import { useInactivityTimeout } from "~/utils/receptionUtils";

/**
 * 来訪者情報入力ページ
 * 受付ヘッダーと来訪者情報入力画面を表示します。
 * ヘッダーの戻る操作をサポートします。
 */
const VisitorInfoInputPage: React.FC = () => {
  const navigate = useNavigate();

  useInactivityTimeout(navigate);

  const handleBack = useCallback(() => {
    runReceptionBack({ kind: "router-history", navigate });
  }, [navigate]);

  return (
    <div className="reception-visitor-info-page">
      <ReceptionHeader showBackButton={true} onBackButtonClick={handleBack} />
      <VisitorInfoInputScreen />
    </div>
  );
};

export default VisitorInfoInputPage;
